var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportTextContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 17.3333H18.6665V14.6666H29.3332V17.3333ZM29.3332 9.33331H18.6665V12H29.3332V9.33331ZM18.6665 22.6666H29.3332V20H18.6665V22.6666ZM15.9998 12V20C15.9998 21.4666 14.7998 22.6666 13.3332 22.6666H5.33317C3.8665 22.6666 2.6665 21.4666 2.6665 20V12C2.6665 10.5333 3.8665 9.33331 5.33317 9.33331H13.3332C14.7998 9.33331 15.9998 10.5333 15.9998 12ZM13.9998 20L11.0665 16L8.6665 19.0666L7.0665 17.0666L4.6665 20H13.9998Z",
    fill: "var(--report-widget-icon-stroke-dark)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportTextContentIcon);
export default __webpack_public_path__ + "static/media/report-text-content-icon.7eba6fed40d09c74a301d555fe903ffb.svg";
export { ForwardRef as ReactComponent };